export default "__VITE_ASSET__D8U6GK3F__"